import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const calculateTimeLeft = () => {
    const targetDate = new Date();
    targetDate.setDate(targetDate.getDate() + 31);
    const difference = targetDate.getTime() - new Date().getTime();

    if (difference <= 0) {
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
    };
};

const Offers = ({ lang, config, ruta }) => {
    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    return (
        <div className="my-6">
            <div className="o-cont-fullw">
                <div className="container">
                    <h3 className="text-center h1">Ofertas destacadas</h3>
                    <app-sale >

                        <div className="container">
                            <app-sale-promo>
                                <div className="c-offer__feat row">
                                    <div className="col-12 col-md">
                                        <figure className="o-fig-object h-100 ratio ratio-16x9">
                                            <img src="https://pro-static.h10hotels.com/gallery/T11D3/31_HESPanoramicView.jpg" alt="Vista panorámica del hotel frente al mar" />
                                        </figure>
                                    </div>
                                    <div className="col-12 col-md o-col-md-mw6">
                                        <div className="o-counter-block">
                                            <app-sale-promo-timer>
                                                <div className="o-counter">
                                                    <div className="dias" id="54ad6129-6261-46c9-b71b-8d1e0ce53d77-days">
                                                        <span>20 <span>Días</span>
                                                        </span>
                                                    </div>
                                                    <div className="o-counter-sep"></div>
                                                    <div className="horas" id="54ad6129-6261-46c9-b71b-8d1e0ce53d77-hours">
                                                        <span>16 <span>Horas</span>
                                                        </span>
                                                    </div>
                                                    <div className="o-counter-sep"></div>
                                                    <div className="minutos" id="54ad6129-6261-46c9-b71b-8d1e0ce53d77-minuts">
                                                        <span>16 <span>Minutos</span>
                                                        </span>
                                                    </div>
                                                    <div className="o-counter-sep"></div>
                                                    <div className="segundos" id="54ad6129-6261-46c9-b71b-8d1e0ce53d77-seconds">
                                                        <span>13 <span>Segundos</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </app-sale-promo-timer>
                                            <p>¡Reserva ya!</p>
                                        </div>

                                        <h3 className="text-center h6 o-title-space">

                                            <strong>El secreto de viajar en primavera</strong>

                                        </h3>
                                        <p className="text-center h6 o-title-space text-primary">
                                            <strong>Código promo: SPRING26</strong>
                                        </p>

                                        <div className="text-center">
                                            <p>Ha llegado la primavera, el momento ideal para descubrir nuevos horizontes.</p>
                                            <p>Regálate una desconexión total con el clima perfecto y disfruta de los beneficios exclusivos de reservar con H10 Hotels:</p>
                                            <p>Reserva antes del 30 de abril y viaja cuando quieras con <strong> hasta un 20% de descuento</strong>. Válido para estancias hasta el 31 de diciembre de 2027. </p>
                                        </div>
                                        <p className="text-center text-md"> Consulta las condiciones <strong>
                                            <a className="open-modal">aquí</a>. </strong>
                                        </p>
                                    </div>
                                </div>
                            </app-sale-promo>



                            <div className="o-cont-fullw">
                                <div className="container">
                                    <div className="cc-offer-swiper centered">
                                        <swiper-container init="false">
                                            <div className="c-card c-card-oferta swiper-slide-active" tabIndex={{ marginRight: "16px" }} role="group" aria-label="1 / 1">
                                                <div className="position-relative">
                                                    <figure className="c-card_img">
                                                        <img className="img" src="https://pro-static.h10hotels.com/gallery/T11D3/12.3_HAGBreakfast3.jpg" alt="Restaurante Modern Art" />
                                                    </figure>
                                                    <div className="c-card-oferta_text">
                                                        <p>

                                                            <strong>Dto. para tu desayuno en una selección de hoteles</strong>

                                                        </p>
                                                    </div>
                                                </div>
                                                <button tabIndex="0" className="btn btn-link">
                                                    {t("Ver detalles")}
                                                    <span className="o-icon arrow">
                                                        <i className="fa-solid fa-arrow-right"></i>
                                                    </span>
                                                </button>
                                            </div>

                                        </swiper-container>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-4 mb-6 c-notification c-notification_rewards-light">
                                <figure className="d-none d-xs-block align-self-start mb-xs-0">
                                    {
                                        config.logo !== "" ?
                                            <img alt="Logo" title="Logo" src={ruta + "/web/logo/web/" + config.logo} />
                                            :
                                            config.logo_fiscal != "" ?
                                                <img alt="Logo" title="Logo" src={ruta + "/web/logo/" + config.logo_fiscal} />
                                                :
                                                <img alt="Logo BedLoop" title="Logo BedLoop" src="https://www.bedloop.com/imatges/logo.webp" />
                                    }
                                </figure>
                                <div className="flex-wrap gap-2 info w-100 d-flex justify-content-between align-items-center">
                                    <div className="gap-3 d-flex">
                                        <figure className="d-xs-none align-self-start">
                                            {
                                                config.logo !== "" ?
                                                    <img alt="Logo" title="Logo" src={ruta + "/web/logo/web/" + config.logo} />
                                                    :
                                                    config.logo_fiscal != "" ?
                                                        <img alt="Logo" title="Logo" src={ruta + "/web/logo/" + config.logo_fiscal} />
                                                        :
                                                        <img alt="Logo BedLoop" title="Logo BedLoop" src="https://www.bedloop.com/imatges/logo.webp" />
                                            }
                                        </figure>
                                        <div>
                                            <p className="mb-1 text-sm fw-semibold text-uppercase">
                                                <span className="text-rewards">{t("5% de descuento")}</span> {t("en todas tus reservas por ser DE VALE REWARDS")}
                                            </p>
                                            <a id="openLogin" className="text-xs" href={`/${preidioma}${t("loginweb")}`}>{t("Ya soy miembro")}</a>
                                        </div>
                                    </div>
                                    <a className="btn btn-rewards" href={`/${preidioma}${t("altasocio")}`}>{t("REGÍSTRATE GRATIS")}</a>
                                </div>
                            </div>
                        </div>

                    </app-sale>
                </div>
            </div>
            <div className="d-flex justify-content-center">
                <a id="seeAllOffersButton" className="btn btn-secondary" href="#">{t("Ver todas las ofertas")}</a>
            </div>
        </div>
    );
};

export default Offers;
